var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 6.477 11.107"}},[_c('path',{attrs:{"d":"M5.297.107L.116 5.298a.35.35 0 000 .512l5.181 5.186a.35.35 0 00.512 0l.556-.556a.35.35 0 000-.512L1.991 5.554 6.366 1.18a.351.351 0 000-.512L5.809.107a.351.351 0 00-.512 0z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }